var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0995dd",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M990 226.3s-159.1 55-339.6 258.9C480 677.7 441.3 754.1 372.7 857.5c0 0-100.7-190.9-362.7-331.5l134.8-129S272 485.2 357 638.8c0 0 216.9-336.7 632.9-496.3l.1 83.8z"
  })));
};
export default SvgCheck;